import { Modal } from "@tyrannosaurustech/ui";

interface CannotDeleteAdminModalProps {
  onConfirm: () => void;
  isOpen: boolean;
}

const CannotDeleteAdminModal = ({
  onConfirm,
  isOpen,
}: CannotDeleteAdminModalProps) => (
  <Modal
    open={isOpen}
    icon="ExclamationTriangleIcon"
    variant="warning"
    title="Can’t delete the only admin"
    cancelText="Got It"
    noConfirm
    onConfirm={() => {}}
    bodyText="Each law firm must have at least one admin. Please assign a new admin before removing this one."
    setOpen={() => onConfirm()}
  />
);

export default CannotDeleteAdminModal;
